module.exports = __webpack_public_path__ + "static/media/2016 - 17 Henry Ho-min.b6e2e38d.jpg";